import React, { useState } from "react";

import { timeZone } from "../../../../data/timeZone";

import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";

import { FaQuestionCircle } from "react-icons/fa";
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import { Checkbox, Form, Input, Select, Button, Col, Row, Card, Popover } from "antd";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./CompanySettings.css";
import FormAction from "../../../../components/common/FormAction";

const { TextArea } = Input;
const CompanySettingsRightBar = [];

const infoPopoverContent = () => {
  return(
    <p className='common-paragraph para'>
      Text messages sent through AppFolio will be sent from these phone numbers. These phone numbers are specific to your company and cannot be edited.
    </p>
  )
}

const taxpNamePopoverContent = () => {
  return(
    <p className='common-paragraph para'>
      Special characters (that is, periods, apostrophes, accents, tildes, etc.) should be removed from the Taxpayer Name. A hyphen (-) and an ampersand (&) are the only acceptable special characters.
    </p>
  )
}

const taxpIdPopoverContent = () => {
  return(
    <p className='common-paragraph para'>
      Valid formats are: xxx-xx-xxxx or xx-xxxxxxx
    </p>
  )
}

const ownerConsentPopoverContent = () => {
  return(
    <p className='common-paragraph para'>
      This form will appear in your owners' portal 1099 settings requesting consent for electronic-only 1099 delivery
    </p>
  )
}

function CompanySettings() {
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  return (
    <>
      <div className="company-settings">
        <PageHeading heading="Company Settings" />
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 11 }}
          initialValues={{ remember: true }}
          autoComplete="off"
          className="form-container"
          colon={false}
        >
          <Row>
            <Col span={24}>
              <Card title="Contact Information" bordered={false}>
                <Form.Item
                  name="companyName"
                  label="Company Name"
                  rules={[{ required: true }]}
                >
                  <Input placeholder="Company Name" />
                </Form.Item>
                <Form.Item
                  name="phoneNumber"
                  label="Phone Number"
                  rules={[{ required: true }]}
                >
                  <Input placeholder="Phone Number here" />
                </Form.Item>
                <Form.Item name="faxNumber" label="Fax Number">
                  <Input placeholder="Company Name" />
                </Form.Item>
                <Form.Item label="Time Zone" rules={[{ required: true }]}>
                  <Select initalvalues="Alaska" showSearch allowClear options={timeZone} placeholder="Start typing to search"/>
                </Form.Item>
                <Form.Item name="website" label="Website">
                  <Input placeholder="Website address here" />
                </Form.Item>
                <Form.Item label={<span className="plain-text">
                    Texting Contact Number(s){" "}
                    <Popover trigger="click" content={infoPopoverContent} title="Texting Phone Number(s)">
                      <FaQuestionCircle size={12} className="circled-question"/>{" "}
                    </Popover>
                    </span>}>
                    <span>+1(251) 577-4036</span>
                </Form.Item>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Card title="Address for Letters and Envolpes" bordered={false}>
                <Form.Item
                  name="Address"
                  label="Address"
                  rules={[{ required: true }]}
                  id="address"
                >
                   <Input placeholder="Address here" />
                </Form.Item>
                <Form.Item label=" ">
                  <Input placeholder="Address 2 here" />
                </Form.Item>
               <Form.Item label=" ">
               <Row gutter={4}>
                  <Col span={12}>
                    <Form.Item>
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item>
                      <Select initalvalues="OK" allowClear showSearch options={[{value: 'OK', label: 'OK'},]} />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item>
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
               </Form.Item>
                <Form.Item label=" ">
                  <Checkbox>Print Return Address On Envelopes</Checkbox>
                </Form.Item>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Card title="Federal Tax Information" bordered={false}>
                <Form.Item label={<span className="plain-text">
                    Taxpayer Name{" "}
                    <Popover trigger="click" content={taxpNamePopoverContent} title="Taxpayer Name">
                      <FaQuestionCircle size={12} className="circled-question"/>{" "}
                    </Popover>
                    </span>}>
                  <Input placeholder="Taxpayer Name here" />
                </Form.Item>
                <Form.Item label=" ">
                  <Checkbox>Use Company Name as Taxpayer Name ?</Checkbox>
                </Form.Item>
                <Form.Item name="taxpayerId" label={<span className="plain-text">
                    Taxpayer ID{" "}
                    <Popover trigger="click" content={taxpIdPopoverContent} title="Taxpayer ID">
                      <FaQuestionCircle size={12} className="circled-question"/>{" "}
                    </Popover>
                    </span>}>
                  <Input placeholder="Taxpayer ID here" />
                </Form.Item>
                <Form.Item
                  name="transCtrlCode"
                  label="Transmitter Control Code for 1099 e-File"
                >
                  <Input placeholder="Transmitter Control Code for 1099 e-File here" />
                </Form.Item>
                <Form.Item
                  name="contactName"
                  label="Contact Name for 1099 e-File"
                >
                  <Input placeholder="Contact Name for 1099 e-File here" />
                </Form.Item>
                <Form.Item
                  name="electronic"
                  label={<span className="plain-text">
                    Owner Consent Form For Electronic 1099s{" "}
                    <Popover trigger="click" content={ownerConsentPopoverContent} title="Owner Consent Form For Electronic 1099s">
                      <FaQuestionCircle size={12} className="circled-question"/>{" "}
                    </Popover>
                    </span>}
                >
                  <TextArea rows={6} />
                </Form.Item>
                <Form.Item label=" ">
                  <Checkbox>
                    Share electronic 1099 consent form in Owner Portal
                  </Checkbox>
                </Form.Item>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Card title="Owner Portal Settings" bordered={false}>
                <Form.Item label=" ">
                  <Checkbox>
                    Use portfolio name, contact information, address, and logo
                    in owner portals and owner communication
                  </Checkbox>
                </Form.Item>
                  <h4>Owner Packet Email Settings</h4>
                  <p className="note-p">
                    <span className="note">Note:</span> If there is no
                    company-wide Return Email Address specified below, emailed
                    Owner Packets will be sent from the email address of the
                    AppFolio user who is sending them.
                  </p>
                <Form.Item label="Return Email Name">
                  <Input placeholder="Return Email Name here" />
                </Form.Item>
                <Form.Item label="Return Email Address">
                  <Input placeholder="Return Email Address here" />
                </Form.Item>
                <Form.Item label="Send BCC to">
                  <Input placeholder="Send BCC to" />
                </Form.Item>
                <Form.Item label="Email Subject Line">
                  <Input placeholder="Email Subject Line here" />
                </Form.Item>
                <Form.Item label="Email Body">
                  <Row>
                    <Col
                      span={24}
                      className="text-editor"
                      style={{
                        border: "1px solid silver",
                        padding: "2px",
                        minHeight: "400px",
                      }}
                    >
                      <Editor
                        editorState={editorState}
                        onEditorStateChange={setEditorState}
                      />
                    </Col>
                  </Row>
                </Form.Item>
                <Row align="center">
                  <Col span={9}><Button type="link" className="reset-email-body">Reset to Default Email Body</Button></Col>
                </Row>
              </Card>
            </Col>
          </Row>
          <FormAction />
        </Form>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={CompanySettingsRightBar} />
      </div>
    </>
  );
}

export default CompanySettings;
